export default "__VITE_ASSET__BMUzL8Yk__"